<template>
  <el-table-column
    prop="receipts"
    sortable="custom"
    label="Bizonylatok"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <el-tooltip
        v-if="scope.row.type === 1"
        class="item"
        effect="dark"
        placement="right"
      >
        <div slot="content">
          <div v-for="receipt in scope.row.receipts">{{ receipt }}</div>
        </div>
        <el-tag size="small">{{ scope.row.receipts.length }} bizonylat</el-tag>
      </el-tooltip>
      <div v-else>
        <span> - </span>
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'receipts',
  };
</script>
